import { Lock, Trophy } from "lucide-react";
import { ACHIEVEMENTS, EGGS, useAchievements } from "@/os/state/achievements";

export function AchievementsPanel() {
    const { unlocked, unlockedCount, eggs, allEggs } = useAchievements();
    return (
        <div data-testid="achievements-panel">
            <p className="font-mono text-[11px] text-inkfaint">progress is saved in your browser. no accounts, no tracking — just badges.</p>
            <div className="xp-track mt-3">
                <div className="xp-fill bg-butterd" style={{ width: `${(unlockedCount / ACHIEVEMENTS.length) * 100}%` }} />
            </div>
            <p className="mt-1 font-mono text-[10.5px] text-inkfaint">
                {unlockedCount}/{ACHIEVEMENTS.length} achievements · {eggs.length}/{EGGS.length} easter eggs
            </p>
            <div className="mt-4 space-y-2">
                {ACHIEVEMENTS.map((a) => {
                    const got = unlocked[a.id];
                    return (
                        <div key={a.id} data-testid={`achievement-${a.id}`} className={`rounded-xl border-2 p-3 ${got ? "border-butterd bg-butter/25" : "border-sand bg-sandsoft/40"}`}>
                            <div className="flex items-center gap-2">
                                {got ? <Trophy size={15} className="flex-none text-butterd" /> : <Lock size={14} className="flex-none text-inkfaint" />}
                                <p className="font-display text-[13.5px] font-extrabold">{a.title}</p>
                                {got && <span className="badge ml-auto border-butterd">unlocked</span>}
                            </div>
                            <p className="mt-1 text-[12.5px] text-inksoft">{a.description}</p>
                            {!got && <p className="mt-1 font-mono text-[10.5px] leading-relaxed text-inkfaint">hint: {a.hint}</p>}
                        </div>
                    );
                })}
            </div>
            {allEggs && (
                <p className="mt-4 rounded-xl border-2 border-butterd bg-butter/30 p-3 font-mono text-[12px]" data-testid="all-eggs-note">
                    YouFoundEverything.txt has appeared in my_brain. go read it.
                </p>
            )}
        </div>
    );
}
